const mutations = {
    menuList(state, item) {
        state.projects = item.projectNameList
        state.createByList = item.createByList
    },
    idList(state, item) {
        // console.log(item);
        state.list = item
    },
    inputChange(state, item) {
        console.log(val);
        val = val.replace(/[^0-9.]/g, '')
    },
    allData(state, item) {
        state.reData = item
    },
    allList(state, item) {
        state.dataAll = item
    },
    setsid(state,value){
        state.uuid=value
    },
    departmentList(state, item) {
        state.departments = item
    },
    save_leftNav(state, leftNav) {
        state.leftNav = leftNav
    },
    nurseNoList(state,item) {
         state.nurseNoList = item
    },
    orderList(state, item) {
        state.orderList = item
    },
    nurseMenuList(state, item) {
        state.nurseMenuData = item
    }

}

export default mutations